import { z } from "zod";
import { TDate } from "./date";

export const TSeenBy = z.record(
  z.string(),
  z.object({
    date: TDate,
  })
);

export type ISeenBy = z.infer<typeof TSeenBy>;
